import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  Tooltip,
  IconButton,
  Divider,
  Stack,
} from "@mui/material";
import { RENTAL_PROPERTY_TABLE_HEADERS } from "../../constant/TableHeaders";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";
import ViewRentalPropertyDialog from "./ViewRentalPropertyDialog";
import DeleteRentalPropertyDialog from "./DeleteRentalPropertyDialog";

const RentalPropertyTable = ({ rows }) => {
  const navigate = useNavigate();
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedRentalPropertyId, setSelectedRentalPropertyId] =
    useState(null);

  const handleViewClick = (property) => {
    setSelectedProperty(property);
    setOpenViewDialog(true);
  };

  const handleViewDialogClose = () => {
    setOpenViewDialog(false);
    setSelectedProperty(null);
  };

  const handleEdit = (id) => {
    navigate(`/rental-property/${id}`, { state: { id: id } });
  };

  const handleDeleteClick = (id) => {
    setSelectedRentalPropertyId(id);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setSelectedRentalPropertyId(null);
  };

  const handleDeleteSuccess = () => {
    setTimeout(() => window.location.reload(), 1000);
  };

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 500 }}>
          <TableHead>
            <TableHeaderRow>
              {RENTAL_PROPERTY_TABLE_HEADERS.map((item, index) => (
                <TableCell
                  key={index}
                  align={item.alignItemTo}
                  sx={{ width: item.width }}
                >
                  {item.title}
                </TableCell>
              ))}
            </TableHeaderRow>
          </TableHead>

          <StyledTableBody>
            {rows.map((row) => (
              <TableBodyRow
                key={row.id}
                hover
                sx={{
                  "&:hover": {
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                <TableCell sx={{ width: 300, alignItemTo: "left" }}>
                  {row.property_name}
                </TableCell>
                <TableCell sx={{ width: 300, alignItemTo: "left" }}>
                  {row.building_name}
                </TableCell>
                <TableCell sx={{ width: 600, alignItemTo: "left" }}>
                  {row.property_address}
                </TableCell>

                <TableCell sx={{ width: 100, alignItemTo: "left" }}>
                  <Stack
                    direction="row"
                    spacing={1}
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Tooltip title="View" arrow>
                      <IconButton
                        onClick={() => handleViewClick(row)}
                        size="small"
                      >
                        <VisibilityOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit" arrow>
                      <IconButton
                        onClick={() => handleEdit(row.id)}
                        size="small"
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        onClick={() => handleDeleteClick(row.id)}
                        size="small"
                      >
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </TableCell>

              </TableBodyRow>
            ))}
          </StyledTableBody>
        </Table>
      </TableContainer>
      
      <ViewRentalPropertyDialog
        open={openViewDialog}
        onClose={handleViewDialogClose}
        rentalProperty={selectedProperty}
      />

      <DeleteRentalPropertyDialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        propertyId={selectedRentalPropertyId}
        onSuccess={handleDeleteSuccess}
      />
    </>
  );
};

export default RentalPropertyTable;
